import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroMangas } from '@/mocks/manga';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = heroMangas.length;

  const next = useCallback(() => setCurrent((prev) => (prev + 1) % total), [total]);
  const prev = useCallback(() => setCurrent((prev) => (prev - 1 + total) % total), [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const manga = heroMangas[current];

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {heroMangas.map((m, i) => (
        <div
          key={m.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={m.coverImage}
            alt={m.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/40 to-background-950/20"></div>

      <div className="absolute inset-0 flex items-end md:items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-lg">
              <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-primary-500 text-background-50 mb-4 whitespace-nowrap">
                今日推荐
              </span>
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-background-50 mb-3">
                {manga.title}
              </h2>
              <p className="text-sm md:text-base text-background-200 leading-relaxed mb-4 line-clamp-2">
                {manga.description}
              </p>
              <div className="flex items-center gap-4 mb-6">
                <span className="flex items-center gap-1 text-sm text-accent-400">
                  <i className="ri-star-fill"></i>
                  {manga.rating}
                </span>
                <span className="text-sm text-background-300">{manga.author}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  manga.status === '连载中' ? 'bg-primary-500/80 text-background-50' : 'bg-secondary-500/80 text-background-50'
                } whitespace-nowrap`}>
                  {manga.status}
                </span>
              </div>
              <Link
                to={`/manga/${manga.id}`}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroMangas.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              i === current ? 'w-8 bg-primary-500' : 'bg-background-400 hover:bg-background-300'
            }`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-950/40 text-background-50 hover:bg-background-950/60 transition-colors cursor-pointer"
        aria-label="Previous slide"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-950/40 text-background-50 hover:bg-background-950/60 transition-colors cursor-pointer"
        aria-label="Next slide"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>
    </section>
  );
}